import {Component, OnInit} from '@angular/core';
import {AbstractBffApi, Log} from '../../../../models/sharedinterface';
import {ApiFactoryService} from '../../../../shared/services/api-factory.service';

@Component({
  selector: 'app-last-logs',
  templateUrl: './last-logs.component.html',
  styleUrls: ['./last-logs.component.scss']
})
export class LastLogsComponent implements OnInit {

  lastLogs: Log[];

  bffapi: AbstractBffApi;

  constructor(private apifactory: ApiFactoryService) {
    this.bffapi = this.apifactory.createBffApi();
  }

  ngOnInit(): void {
    // Fetches app event data
    const query = this.bffapi.getLastLogs();
    query.subscribe((response) => {
      this.lastLogs = response.results;
    });
  }

  public getLogDetailLink(log: Log): string {
    return '/admin/logs/' + log.id + '/';
  }

  public getUsernameElement(log: Log): string {
    if (log.username === 'anonymous') {
      return '<em class="text-muted">@' + log.username + '</em>';
    } else {
      return '<em>@<a href="/admin/users/' + log.userid + '/edit">' + log.username + '</a></em>';
    }
  }

  public getLogLabel(log: Log): string {
    return '<div class="badge bg-' + log.level + '">' + log.level + '</div>';
  }

}
